import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
// logic
import { replace } from 'connected-react-router';
import routes from 'utils/routes';
// state
import { useDispatch, useSelector } from 'react-redux';
import { actions as ordersActions } from 'state/orders';
// components
import { userIsAuthenticatedRedir } from 'components/auth/hoc';
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';
import SoForm from 'refactored/features/soForm/SoForm';
import { SoFormContextProvider } from 'refactored/features/soForm/SoForm.context';
import * as Sentry from '@sentry/react';
import { captureCatalogError } from 'sentry';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { selectors as uiSelectors } from 'state/ui';

const NewShipperOrder = userIsAuthenticatedRedir(({ className }) => {
  const dispatch = useDispatch();

  const catalogStepName = useSelector(uiSelectors.getCatalogStepName);

  // on back, reset data and go to default page
  const handleBack = useCallback(() => {
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.catalogLogoBack({
          from: catalogStepName,
        })
      )
    );
    dispatch(ordersActions.resetData());
    dispatch(replace(routes.orders.default));
  }, [catalogStepName, dispatch]);

  const onError = (e) => {
    captureCatalogError({
      e,
      step_name: null,
      error_type: 'LOGIC',
      action_name: 'NewShipperOrder errorBoundary',
    });
  };

  return (
    <Sentry.ErrorBoundary onError={onError}>
      <AuthenticatedUserView className={className} handleBack={handleBack}>
        <SoFormContextProvider>
          <SoForm />
        </SoFormContextProvider>
      </AuthenticatedUserView>
    </Sentry.ErrorBoundary>
  );
});

NewShipperOrder.propTypes = {
  className: PropTypes.string,
};

export default styled(NewShipperOrder)``;
